export default __webpack_public_path__ + "static/media/errorback.0916c8d2.jpg";